import { studiesLobbyApi } from "@/lib/api";

import { ResolvedStudyReel } from "@digital-twins/shared-types/reporting";

/** The SWR key for one study's reel (`GET /studies/:token/reel`). */
export function studyReelKey(token: string): Array<string> {
  return ["study-reel", token];
}

export function fetchStudyReel(key: Array<string>): Promise<ResolvedStudyReel> {
  return studiesLobbyApi.getReel(key[1]);
}

/** The tokens whose hover prefetch is in flight, so repeated hovers send one. */
const prefetching = new Set<string>();

/**
 * Warm the overlay chunk and the browser's HTTP cache for the reel, so a click
 * opens at once. The prefetch keeps no reel itself: opening always fetches, and
 * the reel route's ETag (`Cache-Control: private, no-cache`) makes that fetch a
 * revalidation, so a hover can never serve a reel or URLs the backend has since
 * replaced.
 */
export function prefetchStudyReel(token: string): void {
  void import("./StudyReelOverlay");
  if (prefetching.has(token)) {
    return;
  }
  prefetching.add(token);
  void studiesLobbyApi
    .getReel(token)
    .catch(() => undefined)
    .finally(() => prefetching.delete(token));
}
